import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";

import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import CustomToast from '../../components/CustomToast';
import LoadingOverlay from '../../components/LoadingOverlay';
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';

// Redux & actions
import * as selector from '../../../common/selectors';
import * as registrationAction from '../../../common/actions/registration';

// Utilities
import AuthManager from '../../../utils/AuthManager';
import Color from "../../../utils/Color";

// React Phone Input
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CustomModal from '../../components/CustomModal';
import { Grid } from '@material-ui/core';
import CustomText from '../../components/CustomText';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

// Regex for email & password
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "2rem",
    paddingLeft: '2.7rem',
    paddingRight: '2.7rem',
    [theme.breakpoints.down('sm')]: {
      paddingTop: "0rem",
      paddingLeft: '0rem',
      paddingRight: '0rem',
    },
  },
  headerText: {
    color: '#000000',
    fontSize: 20,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  labelTextInputTextStyle: {
    fontWeight: 500,
    fontSize: 16,
    color: '#171717',
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  labelTextInputTextStyleError: {
    fontWeight: 500,
    fontSize: 16,
    color: '#EF4444',
  },
  labelTextInputTextStyleSuccess: {
    fontWeight: 500,
    fontSize: 16,
    color: '#10B981',
  },
  textInputContainer: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
  },
  textInputContainerDisabled: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
    backgroundColor: "#F2F2F2",
    color: '#B1B1B1',
  },
  textInputContainerError: {
    height: 48,
    marginBottom: 0,
    marginTop: 5,
    // border: '1px solid #EF4444',
  },
  textInputContainerStrongPassw: {
    height: 48,
    marginBottom: 0,
    marginTop: 5,
    border: '1px solid #10B981',
  },
  // Read-only style for disabled fields
  textInputContainerDis: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
    backgroundColor: "#F2F2F2",
    color: '#B1B1B1',
  },
  errorTextStyle: {
    marginTop: 0,
    marginBottom: 15,
  },
  successTextStyle: {
    marginTop: 0,
    marginBottom: 15,
    color: '#10B981',
  },
  inputContentContainer: {
    marginTop: '1.5rem',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  buttonStyle: {
    height: '48px',
    [theme.breakpoints.down('sm')]: {
      height: '44px',
    },
  },
  modalDesign: {
    padding: 0,
    textAlign: 'center',
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 5,
    [theme.breakpoints.down("xs")]: {
      minWidth: 200,
      marginTop: 20,
      marginBottom: 20,
    },
    [theme.breakpoints.up("sm")]: {
      minWidth: 250,
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 250,
      maxWidth: 250,
    },
    textInputStyle: {
      height: 35,
      marginLeft: 5,
      marginRight: 5,
    },
    containerStyle: {
      flexGrow: 1,
      marginBottom: 30,
      paddingRight: 20,
      marginBottom: 30
    },
    tooltipContainer: {
      display: "flex",
      alignItems: "center",
    },
    titleTextStyle: {
      fontWeight: 'bold',
      fontSize: 25,
    },
  },
  helpText: {
    marginTop: '3.5rem',
    fontSize: '12px',
    color: '#818181',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem',
      fontSize: '11px',
    },
  },
}));

const SPLanding = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // --------------------------
  // Local States
  // --------------------------
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');
  const [dob, setDob] = useState('');
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [registrationFormTypeId, setRegistrationFormTypeId] = useState(null);

  // Redux & other states
  const [regAction, setRegAction] = useState(false);
  const [customToastStatus, setCustomToastStatus] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [verifyOTPAction, setVerifyOTPAction] = useState(false);
  const [successCalled, setSuccessCalled] = useState(false);
  const [localAuthCode, setLocalAuthCode] = useState('');
  const [localAuthState, setLocalAuthState] = useState('');

  // Validation states for Email, Password, and Re-type Password
  const [emailTouched, setEmailTouched] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [retypeTouched, setRetypeTouched] = useState(false);
  const [isRetypePasswordMatch, setIsRetypePasswordMatch] = useState(true);

  // New validation states for Name and UserID
  const [nameTouched, setNameTouched] = useState(false);
  const [nameValid, setNameValid] = useState(true);
  const [userIdTouched, setUserIdTouched] = useState(false);
  const [userIdValid, setUserIdValid] = useState(false);

  // DOB validation states
  const [dobValue, setDobValue] = useState('');
  const [dobTouched, setDobTouched] = useState(false);
  const [isDOBValid, setIsDOBValid] = useState(true);

  // Other states
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [editMobile, setEditMobile] = useState(false);
  const [havingMobile, setHavingMobile] = useState(false);
  const [countdown, setCountdown] = useState(300);
  // Save the original phone number before editing begins.
  const [originalPhoneNumber, setOriginalPhoneNumber] = useState('');
  const [isVisible, setIsVisible] = useState('');

  // Form errors object (to track field errors)
  const [formErrors, setFormErrors] = useState({
    name: false,
    email: false,
    dob: false,
    userId: false,
    password: false,
    retypePassword: false,
  });
  const [backToHome, setBackToHome] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  // Redux Selectors
  const registerNewCustomerData = useSelector(selector.registerNewCustomerData);
  const registerNewCustomerLoading = useSelector(selector.registerNewCustomerLoading);
  const registerNewCustomerStatus = useSelector(selector.registerNewCustomerStatus);
  const getRegistrationCustomerDetailsData = useSelector(selector.getRegistrationCustomerDetailsData);
  const getRegistrationCustomerDetailsLoading = useSelector(selector.getRegistrationCustomerDetailsLoading);
  const getRegistrationCustomerDetailsStatus = useSelector(selector.getRegistrationCustomerDetailsStatus);

  // --------------------------
  // Countdown Timer and initial data fetch
  // --------------------------
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          history.push("/");
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [history]);

  useEffect(() => {
    const authState = getUrlVars()["authState"];
    const authCode = getUrlVars()["authCode"];
    setLocalAuthCode(authCode || '');
    setLocalAuthState(authState || '');
    const inappValue = localStorage.getItem('inapp');
    const data = {
      AuthCode: authCode || '',
      AuthState: authState || '',
      Otp: '',
      OtpReference: '',
      "InApp": inappValue === "1" ? "1" : ""
    };
    dispatch(registrationAction.getRegistrationCustomerDetails(data));
    setVerifyOTPAction(true);
  }, [dispatch]);

  useEffect(() => {
    if (verifyOTPAction && !getRegistrationCustomerDetailsLoading) {
      if (getRegistrationCustomerDetailsStatus && getRegistrationCustomerDetailsData) {
        const regData = getRegistrationCustomerDetailsData.Data;
        const regSuccess = getRegistrationCustomerDetailsData?.Success;
        if (regSuccess) {
          setSuccessCalled(true);
          setName(regData?.Name || '');
          setEmail(regData?.Email || '');
          setPhoneNumber(regData?.Mobile || '');
          if (regData?.Mobile) setHavingMobile(true);
          setDobValue(regData?.Dob || '');
          setRegistrationFormTypeId(regData?.RegistrationFormTypeId || null);
        } else {
          setDisabledBtn(true);
          setSuccessCalled(false);
          //setCustomToastStatus(true);
          setHavingMobile(false);
          //setToastMessage(regData?.Message || 'Something went wrong, Please retry later.');
          setIsVisible(true)
        }
      } else if (!getRegistrationCustomerDetailsStatus && getRegistrationCustomerDetailsData === null) {
        setDisabledBtn(true);
        setSuccessCalled(false);
        //setCustomToastStatus(true);
        setHavingMobile(false);
        //setToastMessage("Something went wrong, Please retry later.");
        setIsVisible(true)
      }
      setVerifyOTPAction(false);
    }
  }, [verifyOTPAction, getRegistrationCustomerDetailsData, getRegistrationCustomerDetailsLoading, getRegistrationCustomerDetailsStatus]);

  useEffect(() => {
    if (regAction && !registerNewCustomerLoading) {
      if (registerNewCustomerStatus && registerNewCustomerData) {
        const regData = registerNewCustomerData.Data?.LoginResponseModel;
        const regSuccess = registerNewCustomerData?.Success;
        const inAppIsCompleted = registerNewCustomerData.Data?.IsCompleted;
        //InApp Flow
        const inappValue = localStorage.getItem('inapp'); // '1' if set, or null if not
        if (regSuccess && inAppIsCompleted && inappValue === "1") {

          localStorage.removeItem("inapp");
          window.location.href = process.env.REACT_APP_INAPP_DEEPLINK + `?code=${localAuthCode}&state=${localAuthState}`;
          return;

        } else if (regSuccess && regData?.AccessToken) {
          localStorage.removeItem("otpCode")
          localStorage.removeItem("OtpRef")
          localStorage.removeItem("MobileCountryCode")
          localStorage.removeItem("newRegCusDetail")
          localStorage.removeItem("ClientMobileNo")
          localStorage.removeItem("NRIC")
          // const inappValue = localStorage.getItem('inapp'); // '1' if set, or null if not
          // if (inappValue === "1") {
          //   localStorage.removeItem("inapp");
          //   window.location.href = process.env.REACT_APP_INAPP_DEEPLINK + `?code=${localAuthCode}&state=${localAuthState}`;
          //   return;
          // }
          AuthManager.setIsMasterAccount(regData?.IsMasterAccount);
          AuthManager.setToken(regData?.AccessToken);
          AuthManager.setSessionID(regData?.SessionId);
          AuthManager.setExpiryWarning(regData?.SessionExpiryWarning);
          AuthManager.setExpiryEnd(regData?.SessionExpiryEnd);
          AuthManager.setDirectClient(regData?.DirectClient);
          window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
        } else {
          setCustomToastStatus(true);
          setToastMessage(registerNewCustomerData.Data?.ErrorMessage || 'Registration failed.');
        }
      } else if (!registerNewCustomerStatus && registerNewCustomerData === null) {
        setCustomToastStatus(true);
        setToastMessage(registerNewCustomerData?.Data?.ErrorMessage || "Something went wrong, Please retry later.");
      }
      setRegAction(false);
    }
  }, [regAction, registerNewCustomerLoading, registerNewCustomerData, registerNewCustomerStatus]);

  const getUrlVars = () => {
    let vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
      return value;
    });
    return vars;
  };
  const regData = getRegistrationCustomerDetailsData?.Data;
  const isDobDisabled = (registrationFormTypeId === 1 || registrationFormTypeId === 3) && (regData?.Dob !== '');
  const isMobileDisabled = registrationFormTypeId === 3 || registrationFormTypeId === 4 || disabledBtn;
  const isNameDisabled = (registrationFormTypeId === 1 || registrationFormTypeId === 3) && (regData?.Name !== '');

  // --------------------------
  // Validation Handlers
  // --------------------------
  const handleEmailChange = (value) => {
    setEmail(value);
    if (!emailTouched && value.length > 0) {
      setEmailTouched(true);
    }
    if (value.length > 0) {
      setIsEmailValid(emailRegex.test(value.trim()));
    } else {
      setIsEmailValid(false);
    }
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    if (!passwordTouched && value.length > 0) {
      setPasswordTouched(true);
    }
    if (value.length > 0) {
      setIsPasswordValid(passwordRegex.test(value));
    } else {
      setIsPasswordValid(false);
      setPasswordTouched(true);
    }
    setIsRetypePasswordMatch(value === retypePassword);
  };

  const handleRetypePasswordChange = (value) => {
    setRetypePassword(value);
    if (!retypeTouched && value.length > 0) {
      setRetypeTouched(true);
    }
    setIsRetypePasswordMatch(password === value);
  };

  const handleNameChange = (value) => {
    setName(value);
    if (!nameTouched && value.length > 0) {
      setNameTouched(true);
    }
    setNameValid(value.length > 0);
  };

  const handleUserIdChange = (value) => {
    setUserId(value);
    if (!userIdTouched && value.length > 0) {
      setUserIdTouched(true);
    }
    //setUserIdValid(value.length > 0);
    if (value.length > 0) {
      const minLengthValid = value.length >= 8;
      const allowedCharsValid = /^[A-Za-z0-9@_.-]+$/.test(value); // Allow letters, numbers, @, _, -, and .
      // Simple NRIC check: assuming NRIC is 9 chars starting with S/T/F/G followed by 7 digits and a letter
      const isNotNRIC = !/^[STFG]\d{7}[A-Z]$/i.test(value);

      // Set idValid true only if all conditions are met
      setUserIdValid(minLengthValid && allowedCharsValid && isNotNRIC);
    } else {
      setUserIdValid(false);
    }
  };

  // Final Activation with checking errors
  const onClickActivate = () => {
    // alert(`${name}${nameValid}`)
    // return;
    const errorsFound = {
      name: !name || !nameValid,
      email: !email || !isEmailValid,
      dob: !dobValue || !isDOBValid,
      userId: !userId || !userIdValid,
      password: !password || !isPasswordValid,
      retypePassword: !retypePassword || !isRetypePasswordMatch,
    };
    setFormErrors(errorsFound);
    if (Object.values(errorsFound).some(val => val)) {
      setCustomToastStatus(true);
      setToastMessage("Please fill in all required fields correctly.");
      return;
    }
    const data = {
      FullName: name,
      AuthCode: localAuthCode,
      AuthState: localAuthState,
      //Otp: "",
      //OtpReference: "",
      Email: email,
      Mobile: phoneNumber,
      MobileCountryCode: (phoneCountryCode === "65" || phoneCountryCode === "+65") ? "" : phoneCountryCode,
      Password: password,
      ConfirmPassword: retypePassword,
      UserId: userId,
      Dob: dobValue,
      RegistrationFormTypeId: registrationFormTypeId
    };
    dispatch(registrationAction.registerNewCustomer(data));
    setRegAction(true);
  };

  // --------------------------
  // Toast Close Handler
  // --------------------------
  const handleCloseCustomToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setCustomToastStatus(false);
  };

  // --------------------------
  // DOB Change Handler
  // --------------------------
  const handleDOBChange = (raw) => {
    let digits = raw.replace(/\D/g, '').slice(0, 8);
    let display = digits;
    if (digits.length >= 5) {
      display = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
    } else if (digits.length >= 3) {
      display = digits.slice(0, 2) + '/' + digits.slice(2);
    }
    setDobTouched(true);
    setDobValue(display);
    if (digits.length === 8) {
      const dd = parseInt(digits.slice(0, 2), 10);
      const mm = parseInt(digits.slice(2, 4), 10);
      const yyyy = parseInt(digits.slice(4, 8), 10);
      const dt = new Date(yyyy, mm - 1, dd);
      const validDate = (dt.getFullYear() === yyyy && dt.getMonth() === (mm - 1) && dt.getDate() === dd);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const notFuture = dt.getTime() <= today.getTime();
      setIsDOBValid(validDate && notFuture);
    } else {
      setIsDOBValid(false);
    }
  };

  // --------------------------
  // Phone Change Handler
  // --------------------------
  const handlePhoneChange = (value, countryData) => {
    const numericValue = value.replace(/\D/g, '');
    setPhoneCountryCode(countryData.dialCode);
    setPhoneNumber(value);
  };

  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleClickShowRetypePassword = () => {
    setShowRetypePassword(prev => !prev);
  };

  // Prevent default mouse down behavior (optional, for better UX)
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  // --------------------------
  // Render Page with dynamic styles and error props
  // --------------------------
  const renderPage = () => {
    // Dynamic styles for Name
    const nameTextStyle = (formErrors.name || (nameTouched && !nameValid))
      ? classes.labelTextInputTextStyleError
      : classes.labelTextInputTextStyle;
    const nameDesign = (formErrors.name || (nameTouched && !nameValid))
      ? classes.textInputContainerError
      : classes.textInputContainer;
    // Dynamic styles for Email
    const emailTextStyle = (formErrors.email || (emailTouched && !isEmailValid))
      ? classes.labelTextInputTextStyleError
      : classes.labelTextInputTextStyle;
    const emailDesign = (formErrors.email || (emailTouched && !isEmailValid))
      ? classes.textInputContainerError
      : classes.textInputContainer;
    // Dynamic styles for DOB
    const dobTextStyle = (formErrors.dob || (dobTouched && !isDOBValid))
      ? classes.labelTextInputTextStyleError
      : classes.labelTextInputTextStyle;
    const dobDesign = (formErrors.dob || (dobTouched && !isDOBValid))
      ? classes.textInputContainerError
      : classes.textInputContainer;
    // Dynamic styles for UserID
    const userIdTextStyle = (formErrors.userId || (userIdTouched && !userIdValid))
      ? classes.labelTextInputTextStyleError
      : classes.labelTextInputTextStyle;
    const userIdDesign = (formErrors.userId || (userIdTouched && !userIdValid))
      ? classes.textInputContainerError
      : classes.textInputContainer;
    // Dynamic styles for Password
    const passwordTextStyle = (passwordTouched && isPasswordValid)
      ? classes.labelTextInputTextStyleSuccess
      : ((passwordTouched || formErrors.password)
        ? classes.labelTextInputTextStyleError
        : classes.labelTextInputTextStyle);
    const passwordDesign = (passwordTouched && isPasswordValid)
      ? classes.textInputContainerStrongPassw
      : ((passwordTouched || formErrors.password)
        ? classes.textInputContainerError
        : classes.textInputContainer);
    // Dynamic styles for Re-type Password
    const retypeTextStyle = (formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch))
      ? classes.labelTextInputTextStyleError
      : classes.labelTextInputTextStyle;
    const retypeDesign = (formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch))
      ? classes.textInputContainerError
      : classes.textInputContainer;

    const errors = {
      name: !name || !nameValid,
      email: !email || !isEmailValid,
      dob: !dobValue || !isDOBValid,
      userId: !userId || !userIdValid,
      password: !password || !isPasswordValid,
      retypePassword: !retypePassword || !isRetypePasswordMatch,
    };
    const isFormInvalid = Object.values(errors).some(val => val);
    return (
      <div className={classes.container}>
        <div className={classes.headerText}>
          Please fill in your details
        </div>
        <div className={classes.inputContentContainer}>
          {/* Name */}
          <CustomTextInput
            title="Name"
            textstyle={nameTextStyle}
            design={(disabledBtn || isNameDisabled) ? classes.textInputContainerDis : nameDesign}
            fullWidth
            value={name}
            onChange={(e) => {
              handleNameChange(e.target.value);
              setFormErrors(prev => ({ ...prev, name: false }));
            }}
            onBlur={() => { if (!name) setNameTouched(true); }}
            error={formErrors.name || (nameTouched && !nameValid)}
            errorMessage="Please enter your name."
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn || isNameDisabled}
          />
          {/* Email */}
          <CustomTextInput
            title="Email"
            textstyle={emailTextStyle}
            design={disabledBtn ? classes.textInputContainerDis : emailDesign}
            fullWidth
            value={email}
            onChange={(e) => {
              handleEmailChange(e.target.value);
              setFormErrors(prev => ({ ...prev, email: false }));
            }}
            onBlur={() => { if (!email) setEmailTouched(true); }}
            error={formErrors.email || (emailTouched && !isEmailValid)}
            errorMessage={!email ? "Please enter your email." : "Please enter a valid email."}
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn}
          />
          {/* Mobile Number */}
          <div style={{ width: '100%' }}>
            <div className={classes.labelTextInputTextStyle} style={{ marginBottom: 5, fontWeight: "400" }}>
              Mobile Number
            </div>
            {isMobileDisabled || (!editMobile && havingMobile) ? (
              <CustomTextInput
                value={phoneNumber}
                design={classes.textInputContainerDis}
                disabled
                fullWidth
                endAdornment={
                  !isMobileDisabled ? (
                    <span
                      style={{ cursor: "pointer", color: '#10B981' }}
                      onClick={() => { setOriginalPhoneNumber(phoneNumber); setEditMobile(true); setHavingMobile(false); setPhoneNumber(''); }}
                    >
                      Edit
                    </span>
                  ) : null
                }
              />
            ) : (
              <div style={{ marginBottom: 25 }}>
                <PhoneInput
                  country={'sg'}
                  value={phoneNumber}
                  onChange={(val, countryData) => handlePhoneChange(val, countryData)}
                  inputStyle={{ width: '100%', height: '48px' }}
                  enableSearch
                  countryCodeEditable={false}
                />
                {editMobile && (
                  <div style={{ width: '100%', position: 'relative', top: '-2.2rem', left: '-10px', textAlign: 'right' }}>
                    <span
                      style={{ cursor: "pointer", color: '#10B981' }}
                      onClick={() => {
                        // Revert to the original phone number and exit edit mode
                        setPhoneNumber(originalPhoneNumber);
                        setHavingMobile(true);
                        setEditMobile(false);
                      }}
                    >
                      Cancel
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
          {/* DOB */}
          {console.log("whats this",disabledBtn,isDobDisabled,dobValue)}
          <CustomTextInput
            title="Date of Birth"
            textstyle={dobTextStyle}
            design={(disabledBtn || isDobDisabled) ? classes.textInputContainerDis : dobDesign}
            fullWidth
            value={dobValue}
            onChange={(e) => {
              handleDOBChange(e.target.value);
              setFormErrors(prev => ({ ...prev, dob: false }));
            }}
            onBlur={() => { if (!dobValue || !isDOBValid) setDobTouched(true); }}
            error={formErrors.dob || (dobTouched && !isDOBValid)}
            errorMessage={!dobValue ? "Please enter your date of birth." : "Invalid date or future date. Use DD/MM/YYYY."}
            errorTextStyle={classes.errorTextStyle}
            placeholder="DD/MM/YYYY"
            disabled={disabledBtn || isDobDisabled}
          />
          {/* UserID */}
          <CustomTextInput
            title="Choose UserID"
            textstyle={userIdTextStyle}
            design={disabledBtn ? classes.textInputContainerDis : userIdDesign}
            fullWidth
            value={userId}
            onChange={(e) => {
              handleUserIdChange(e.target.value);
              setFormErrors(prev => ({ ...prev, userId: false }));
            }}
            onBlur={() => { if (!userId) setUserIdTouched(true); }}
            error={formErrors.userId || (userIdTouched && !userIdValid)}
            errorMessage="Please choose a UserID."
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn}
            toolTip={true}
            // toolTipText={`Username requirements:`}
            //toolTipText2={`tetsdomk`}
            toolTipTexts={["Username requirements:", "• Minimum 8 characters", "• Only letters, numbers and '@' / '_' /  '-'  can be used", "• Username cannot be NRIC"]}
          />

          {userIdTouched && <div style={{ marginBottom: 30, marginTop: -10 }}>
            <CustomText style={{ marginTop: 0, fontWeight: 'bold' }}>
              Username requirements:
            </CustomText>
            <div style={{ marginLeft: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {userId.length >= 8 ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>Minimum 8 characters</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/^[A-Za-z0-9@_-]+$/.test(userId) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>
                  Only letters, numbers and '@' / '_' / '-' can be used
                </CustomText>
              </div>
            </div>
          </div>}
          {/* Password */}
          <CustomTextInput
            title="Choose Password"
            textstyle={passwordTextStyle}
            design={passwordDesign}
            fullWidth
            type={showPassword ? 'text' : 'password'} 
            value={password}
            onChange={(e) => {
              handlePasswordChange(e.target.value);
              setFormErrors(prev => ({ ...prev, password: false }));
            }}
            //onBlur={() => { if (!password || !passwordRegex.test(password)) setPasswordTouched(true); }}
            error={formErrors.password || (passwordTouched && !isPasswordValid)}
            errorMessage={!password ? "Please enter a password." : "Weak Password"}
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn}
            success={isPasswordValid && passwordTouched && password.length > 0}
            successMessage={'Strong Password'}
            successTextStyle={classes.successTextStyle}
            toolTip={true}
            toolTipTexts={["Password requirements:", "• Minimum 8 Characters", "• At least 1 uppercase", "• At least 1 lowercase", "• At least 1 number", "• At least 1 special character"]}
            endAdornment={(
              <IconButton
                aria-label="toggle retype password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showRetypePassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            )}
          />

          {passwordTouched && <div style={{ marginBottom: 30, marginTop: -10 }}>
            <CustomText style={{ fontWeight: 'bold', marginBottom: 8 }}>
              Password requirements:
            </CustomText>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {password.length >= 8 ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>Minimum 8 Characters</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/[A-Z]/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 uppercase</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/[a-z]/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 lowercase</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/\d/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 number</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/[^A-Za-z0-9]/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 special character</CustomText>
              </div>
            </div>
          </div>}

          {/* Re-type Password */}
          <CustomTextInput
            title="Re-type Password"
            textstyle={retypeTextStyle}
            design={disabledBtn ? classes.textInputContainerDis : retypeDesign}
            fullWidth
            type={showRetypePassword ? 'text' : 'password'}
            value={retypePassword}
            onChange={(e) => {
              handleRetypePasswordChange(e.target.value);
              setFormErrors(prev => ({ ...prev, retypePassword: false }));
            }}
            onBlur={() => { if (!retypePassword || password !== retypePassword) setRetypeTouched(true); }}
            error={formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)}
            errorMessage={!retypePassword ? "Please re-type your password." : "Passwords do not match."}
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn}
            endAdornment={(
              <IconButton
                aria-label="toggle retype password visibility"
                onClick={handleClickShowRetypePassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showRetypePassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            )}
          />
        </div>
        <div style={{ width: '100%', marginTop: '1rem' }}>
          <CustomButton
            title="Register / Activate"
            design={classes.buttonStyle}
            onClick={onClickActivate}
            disabled={disabledBtn || isFormInvalid}
          />
        </div>

        <div className={classes.helpText}>
          If you encounter any issues, please contact our Customer Service Centre
          via our hotline +65 6887 8777 or WhatsApp us at +65 6887 8777
        </div>

      </div>
    );
  };

  const renderMaintenanceChild = () => <></>;
  const height = 800;
  const width = 600;

  const modalContainer = () => {
    return (
      <div className={classes.containerStyle}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.tooltipContainer}>
              <CustomText design={classes.titleTextStyle} style={{ marginBottom: 10 }}>
                {getRegistrationCustomerDetailsData?.Data?.Message || "Something went wrong, Please retry later."}
              </CustomText>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const onClickNextButton = () => {
    history.push("/")

  };

  return (
    <>
      <CustomBoardNewLogin
        maintenanceChild={renderMaintenanceChild()}
        children={renderPage()}
        height={height}
        width={width}
      />
      <CustomToast
        open={customToastStatus}
        handleCloseCustomToast={handleCloseCustomToast}
        title={toastMessage}
        backToHome={backToHome}
        warning
      />
      <CustomModal
        open={isVisible}
        //handleClose={handleClose}
        //titlestyle={classes.modalTitleStyle}
        modalDesign={classes.modalDesign}
        submitButtonText={"OK"}
        //cancelButtonText={"Cancel"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={() => onClickNextButton()}
        isVisibleCloseButton={false}
        okBtnSty={true}
      // handleCancelButton={handleClose}
      />
      {registerNewCustomerLoading && <LoadingOverlay loading={true} />}
    </>
  );
};

export default SPLanding;
